import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "count", "rows", "row", "togglePrefix", "blueprint"]

  connect() {
    this.disableBlueprintFields()
    this.updateCount()
    this.updateTogglePrefix()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    if (!this.hasPanelTarget) return

    this.panelTarget.classList.toggle("d-none")
    this.updateTogglePrefix()
  }

  add(event) {
    event.preventDefault()
    event.stopPropagation()
    if (!this.hasRowsTarget || !this.hasBlueprintTarget) return

    const index = `${Date.now()}${Math.floor(Math.random() * 1000)}`
    const wrapper = document.createElement("div")
    wrapper.innerHTML = this.blueprintHtml().replace(/__CONSUMIBLE__/g, index)

    wrapper.querySelectorAll("input, select, textarea, button").forEach((el) => {
      el.disabled = false
      el.removeAttribute("data-consumible-blueprint-field")
    })

    const row = wrapper.querySelector(".orden-consumible-form-wrapper")
    if (!row) return

    row.dataset.newRecord = "true"
    this.rowsTarget.appendChild(row)
    this.updateCount()
  }

  remove(event) {
    event.preventDefault()
    event.stopPropagation()

    const wrapper = event.target.closest(".orden-consumible-form-wrapper")
    if (!wrapper || this.blueprintContains(wrapper)) return

    if (wrapper.dataset.newRecord === "true" || wrapper.querySelector("input[name*='[id]']") == null) {
      wrapper.remove()
    } else {
      wrapper.style.display = "none"
      const destroyInput = wrapper.querySelector("input[name*='[_destroy]']")
      if (destroyInput) destroyInput.value = "1"
    }

    this.updateCount()
  }

  disableBlueprintFields() {
    if (!this.hasBlueprintTarget) return

    this.blueprintRoot().querySelectorAll("input, select, textarea, button").forEach((el) => {
      el.disabled = true
      el.setAttribute("data-consumible-blueprint-field", "true")
    })
  }

  updateCount() {
    if (!this.hasCountTarget) return
    this.countTarget.textContent = this.visibleRows().length.toString()
  }

  updateTogglePrefix() {
    if (!this.hasTogglePrefixTarget) return
    const open = this.hasPanelTarget && !this.panelTarget.classList.contains("d-none")
    this.togglePrefixTarget.textContent = open ? "−" : "+"
  }

  visibleRows() {
    return this.rowTargets.filter((row) => {
      if (this.blueprintContains(row)) return false

      const destroyInput = row.querySelector("input[name*='[_destroy]']")
      if (destroyInput && (destroyInput.value === "1" || destroyInput.value === "true")) return false
      return row.style.display !== "none"
    })
  }

  blueprintHtml() {
    return this.blueprintTarget.innerHTML
  }

  blueprintRoot() {
    if (this.blueprintTarget instanceof HTMLTemplateElement) {
      return this.blueprintTarget.content
    }
    return this.blueprintTarget
  }

  blueprintContains(node) {
    if (!this.hasBlueprintTarget) return false
    if (this.blueprintTarget instanceof HTMLTemplateElement) {
      return this.blueprintTarget.content.contains(node)
    }
    return this.blueprintTarget.contains(node)
  }
}
